
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  description: 'Maximize performance and security of manual entry Auth methods'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Anti-fraud best practices' subtitle='Optimally configure manual entry verification methods to reduce fraud' mdxType="Header" />
    <p>{`Plaid provides a suite of fraud prevention products that assist your application in catching bad actors and ACH returns. You can verify the source
of funds with `}<a parentName="p" {...{
        "href": "/docs/identity"
      }}>{`Identity`}</a>{`, confirm the real-time `}<a parentName="p" {...{
        "href": "/docs/balance"
      }}>{`Balance`}</a>{` prior to a transfer, and leverage Plaid's ML-based `}<a parentName="p" {...{
        "href": "/docs/signal"
      }}>{`Signal Transaction Scores`}</a>{` to prevent returns and release funds earlier. These features are fully compatible with accounts connected via Instant Auth, Instant Match, and Automated Micro-deposits.`}</p>
    <p>{`However, if an account is connected via a manual entry method such as Same-Day Micro-deposits, Instant Micro-deposits, or Database Auth, or if the account type is a `}<a parentName="p" {...{
        "href": "/docs/auth/#enabling-limited-purpose-checking-accounts-for-rent-or-mortgage"
      }}>{`limited-purpose checking account`}</a>{`, these features are not always available, which could increase the likelihood that you experience fraud and ACH returns. Following the recommendations below can help mitigate these risks.`}</p>
    <h5 {...{
      "id": "use-identity-match-signal-andor-identity-document-upload"
    }}>{`Use Identity Match, Signal, and/or Identity Document Upload`}</h5>
    <p>{`Approximately 30% of Items created with manual entry methods (including 100% of Items created by Database Auth that have a `}<inlineCode parentName="p">{`database_insights_pass`}</inlineCode>{` verification status) are supported by `}<inlineCode parentName="p">{`/identity/match`}</inlineCode>{`, which allows you to determine the likelihood that the user's identity details, such as name and address, on file with their financial institution match identity information held by you. For more details on this feature, see `}<a parentName="p" {...{
        "href": "/docs/identity/#identity-match"
      }}>{`Identity`}</a>{`.`}</p>
    <p>{`The same Items that are supported by `}<inlineCode parentName="p">{`/identity/match`}</inlineCode>{` are also supported by Signal Transaction Scores. Signal Transaction Scores can assess the return risk of a transaction based on machine learning analysis and alert you to high-risk transactions. For more details, see `}<a parentName="p" {...{
        "href": "/docs/signal"
      }}>{`Signal Transaction Scores`}</a>{`. `}</p>
    <p><a parentName="p" {...{
        "href": "/docs/identity/identity-document-upload"
      }}>{`Identity Document Upload`}</a>{` verifies account owner identity based on bank statements, and is compatible with Items that don't support `}<inlineCode parentName="p">{`/identity/match`}</inlineCode>{` or `}<inlineCode parentName="p">{`/identity/get`}</inlineCode>{`. After creating the Item, you can use update mode to send the user through a Link session where they will be asked to upload a bank statement. Plaid will then analyze this statement for an account number match and will parse identity data from the statement. With the optional Fraud Risk feature, you can also check the uploaded statement for signs of fraud. For more details, see `}<a parentName="p" {...{
        "href": "/docs/identity/identity-document-upload"
      }}>{`Identity Document Upload`}</a>{`.`}</p>
    <p>{`Limited-purpose checking accounts, while not compatible with Balance, are compatible with Signal Transaction Scores, Identity, and Identity Match. Using some combination of these products can reduce ACH return risk when working with limited-purpose checking accounts. `}</p>
    <h5 {...{
      "id": "adjust-a-users-link-experience-based-on-their-risk-profile"
    }}>{`Adjust a user's Link experience based on their risk profile`}</h5>
    <p>{`In order to reduce fraud upstream on your application, you can use `}<a parentName="p" {...{
        "href": "/docs/identity-verification"
      }}>{`Plaid Identity Verification`}</a>{` to verify a government ID or match with a selfie of the document holder. `}</p>
    <Callout warning mdxType="Callout">
If your application does not have an identity verification solution or Plaid Link is not gated from the general public with fraud prevention 
and user verification checks in place, we do not recommend adopting manual entry verification methods as it may introduce an unnecessary fraud vector onto 
your platform. 
    </Callout>
    <p>{`If you identify a user to be riskier, consider disabling manual entry verification methods for those users.`}</p>
    <p>{`Another option for riskier users is to leave manual entry verification methods enabled, but enable `}<a parentName="p" {...{
        "href": "/docs/auth/coverage/flow-options/#forced-reroute"
      }}>{`Reroute to Credentials in Forced mode`}</a>{`, which will only allow
the user to link via manual entry verification methods when using a routing number not supported by other authentication methods.`}</p>
    <p>{`You may also consider changing your user's experience with your service based on their connection method or available data. For example, if a user connected via a manual entry verification method, you may consider enforcing a lower transfer threshold than for users where it was possible to verify identity and increasing hold times on those funds.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
